import React from "react";
import MAppBar from '@mui/material/AppBar';

const AppBar = (props) => {
    return (
        <MAppBar {...props} />
    )
}

export default AppBar;